var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.237 20.64 2.397 2.628L31 11.748l-2.088-8.506L20.252 1l-3.015 3.17 2.397 2.706 1.546-1.855 5.026 1.083.696 4.562-9.665 9.974zm6.03-8.274-2.628 2.397-9.975-9.665-4.562.696-1.082 5.026 1.856 1.546-2.706 2.397L1 11.747l2.242-8.66L11.747 1l11.52 11.366zm-8.504-1.005-2.397-2.628L1 20.252l2.088 8.506L11.748 31l3.015-3.17-2.397-2.706-1.546 1.855-5.026-1.083-.696-4.562 9.665-9.974zm-3.402 5.877-2.628 2.397L20.252 31l8.506-2.088L31 20.252l-3.17-3.015-2.706 2.397 1.855 1.546-1.083 5.026-4.562.696-9.974-9.665z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtm);
export default __webpack_public_path__ + "static/media/BTM.a7b94105bac5646932ad769b0ec45a50.svg";
export { ForwardRef as ReactComponent };